import {
  ScreenSizeGetFeatureIntrosV1,
  type FeatureIntroStepGetResponseObjectNetworkModel,
  type GetFeatureIntrosV1200ResponseNetworkModel,
  type SingleFeatureIntroGetResponseObjectNetworkModel
} from '@norlys-a-s/norlys-play-kmm';
import { AvailableFeatureIntros, FeatureIntroLocation } from '@smart-tv/typings/content';

import { ntvbApiCall } from './kmm';

const stepMapper = (
  step: FeatureIntroStepGetResponseObjectNetworkModel
): AvailableFeatureIntros[number]['steps'][number] => ({
  id: step.id,
  headline: step.headline,
  subHeadline: step.subHeadline ?? undefined,
  description: step.description,
  link: step.link ? { text: step.link.text, url: step.link.url } : undefined,
  media: step.media
    ? { mediaType: step.media.mediaType.value, mediaUrl: step.media.mediaUrl }
    : undefined
});

const locationToShowIntroMapper = (location: { name: string }): FeatureIntroLocation => {
  switch (location.name) {
    case 'FRONTPAGE':
      return FeatureIntroLocation.FRONTPAGE;
    case 'PLAYER':
      return FeatureIntroLocation.PLAYER;
    case 'LIVE_PLAYER':
      return FeatureIntroLocation.LIVE_PLAYER;
    case 'VOD_PLAYER':
      return FeatureIntroLocation.VOD_PLAYER;
    case 'SFF_PLAYER':
      return FeatureIntroLocation.SFF_PLAYER;
    default:
      throw new Error(`Unknown locationToShowIntro: ${location.name}`);
  }
};

const responseMapper = (data: GetFeatureIntrosV1200ResponseNetworkModel): AvailableFeatureIntros =>
  Array.from(data.availableFeatureIntros.asJsReadonlyArrayView()).map(
    (intro: SingleFeatureIntroGetResponseObjectNetworkModel) => ({
      id: intro.id,
      name: intro.name,
      locationToShowIntro: locationToShowIntroMapper(intro.locationToShowIntro),
      style: intro.style.value,
      steps: Array.from(intro.steps.asJsReadonlyArrayView()).map(stepMapper)
    })
  );

export const getActiveFeatureIntros = async (
  screenSize: ScreenSizeGetFeatureIntrosV1 = ScreenSizeGetFeatureIntrosV1.LARGE,
  draftVersionsSecret?: string
): Promise<AvailableFeatureIntros> => {
  const data = await ntvbApiCall((api) =>
    api.getActiveFeatureIntros(screenSize, draftVersionsSecret)
  );
  return responseMapper(data);
};

export default getActiveFeatureIntros;
